import Skeleton from '@mui/material/Skeleton';
import { Box, Divider, Stack } from '@mui/material';
import { NavigateListItemStyled } from './Navigator/style';
import { CustomAccordion } from '../../components/Accordion';
import { PaperBox } from '../../style/GlobalStyles';

export const skeleton = (
    <>
        <Box display={'flex'} height={'100%'}>
            {/* Left Side Navigate UI */}
            <PaperBox component={'div'}>
                <Skeleton variant="text" sx={{ height: '2rem' }} />

                <Stack
                    spacing={2}
                    component={'ul'}
                    sx={{
                        listStyleType: 'none',

                        mt: '1.25rem',
                    }}
                >
                    {Array.from(Array(6).keys()).map((index) => (
                        <CustomAccordion
                            key={index}
                            component={NavigateListItemStyled}
                            expandIcon={<Skeleton variant="circular" width={10} height={10} />}
                            details={
                                <>
                                    {Array.from(Array(6).keys()).map((index) => (
                                        <Box
                                            key={index}
                                            sx={(theme) => ({
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginLeft: `1.8rem`,

                                                padding: `${theme.typography.generic.xSmall}`,

                                                borderRadius: theme.typography.borderRadius.xxSmall,

                                                '&:first-of-type': {
                                                    marginTop: '0.5rem',
                                                },

                                                cursor: 'pointer',
                                            })}
                                            role="button"
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    width: '100%',
                                                }}
                                            >
                                                <Skeleton variant="text" sx={{ width: '90%', height: '1.5rem' }} />
                                            </Box>
                                        </Box>
                                    ))}
                                </>
                            }
                            summary={
                                <>
                                    <Skeleton variant="circular" width={40} height={40} />
                                    <Box sx={{ ml: 2, display: 'flex', alignItems: 'start', flexDirection: 'column' }}>
                                        <Skeleton variant="text" sx={{ width: '9rem' }} />
                                        <Skeleton variant="text" sx={{ width: '5rem' }} />
                                    </Box>
                                </>
                            }
                        ></CustomAccordion>
                    ))}
                </Stack>
            </PaperBox>

            <Divider orientation="vertical" variant="middle" flexItem />

            {/* Right Side UI */}
            <PaperBox
                sx={(theme) => ({
                    flex: 1,

                    [theme.breakpoints.down('md')]: {
                        display: 'none',
                    },
                    [theme.breakpoints.down('sm')]: {
                        display: 'none',
                    },
                })}
            >
                <Box>
                    <Box
                        className=""
                        display={'flex'}
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        width={{
                            xs: '100%',
                            sm: 'unset',
                        }}
                    >
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton variant="text" sx={{ width: '9rem', marginLeft: '0.5rem', height: '1.5rem' }} />

                        {/* <Box
                            component={'span'}
                            sx={(theme) => ({
                                color: theme.palette.success.main,
                                backgroundColor: alpha(theme.palette.success.main, 0.08),
                            })}
                        >
                            <Skeleton variant="text" sx={{ width: '5rem' }} />
                        </Box> */}
                    </Box>
                </Box>

                <Divider
                    sx={{
                        m: '1rem 0',
                    }}
                />

                <Box>
                    <Skeleton variant="text" sx={{ width: '9rem', height: '1.5rem' }} />
                    <Skeleton variant="text" sx={{ width: '100%', height: '5rem' }} />

                    <Box marginTop={'1rem'}>
                        <Skeleton variant="text" sx={{ width: '9rem' }} />
                        <Box>
                            {Array.from(Array(6).keys()).map((index) => (
                                <Skeleton key={index} variant="text" sx={{ height: '1.5rem' }} />
                            ))}
                        </Box>
                    </Box>
                </Box>

                <Divider
                    sx={{
                        m: '1rem 0',
                    }}
                />

                <Box>
                    <Skeleton variant="text" sx={{ fontSize: '0.5rem', width: '30%' }} />
                    <Box
                        className=""
                        display={'flex'}
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        width={{
                            xs: '100%',
                            sm: 'unset',
                        }}
                        marginTop={'0.5rem'}
                        marginBottom={'0.5rem'}
                        sx={(theme) => ({
                            padding: `${theme.typography.generic.medium} ${theme.typography.generic.xLarge}`,
                            margin: `${theme.typography.generic.xLarge} ${theme.typography.generic.none}`,
                            borderRadius: theme.typography.borderRadius.xSmall,
                            border: `1px solid ${theme.palette.grey[300]}`,

                            flexDirection: {
                                xs: 'column',
                                sm: 'row',
                            },
                        })}
                    >
                        <Skeleton
                            variant="circular"
                            width={40}
                            height={40}
                            sx={{
                                minWidth: '40px',
                                minHeight: '40px',
                            }}
                        />
                        <Skeleton variant="text" sx={{ width: '35%', marginLeft: '0.5rem', marginRight: '0.5rem', height: '1.5rem' }} />

                        <Box display={'flex'} flex={1} justifyContent={'end'}>
                            <Skeleton variant="rounded" width={210} height={30} />
                        </Box>

                        {/* <Box
                            component={'span'}
                            sx={(theme) => ({
                                color: theme.palette.success.main,
                                backgroundColor: alpha(theme.palette.success.main, 0.08),
                            })}
                        >
                            <Skeleton variant="text" sx={{ width: '5rem' }} />
                        </Box> */}
                    </Box>
                    <Skeleton variant="text" sx={{ fontSize: '0.5rem', width: '30%' }} />
                </Box>

                <Divider
                    sx={{
                        m: '1rem 0',
                    }}
                />

                <Box>
                    <Skeleton variant="text" sx={{ height: '1.5rem', width: '30%' }} />

                    <Box
                        sx={{
                            display: 'flex',

                            flexDirection: {
                                xs: 'column',
                                sm: 'row',
                            },

                            marginTop: '0.5rem',
                        }}
                    >
                        <Skeleton
                            variant="rounded"
                            sx={{
                                width: '40%',
                                height: '11rem',
                            }}
                        />

                        <Box width={'60%'} marginLeft={'1rem'}>
                            <Skeleton variant="text" sx={{ height: '1.5rem', width: '40%' }} />
                            <Skeleton variant="text" sx={{ height: '2rem', width: '70%' }} />
                            <Skeleton variant="text" sx={{ height: '2rem', width: '70%' }} />
                        </Box>
                    </Box>
                </Box>
            </PaperBox>
        </Box>

        {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: '0px', left: '0px', width: '100%', height: '100%', background: 'white' }}>
            <CircularProgress />
        </Box> */}
    </>
);
